import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';

 
class ServicesContent extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            content : [],
            page_content:[],
            loading : 1,
            settings:{}
        }
        

    }

    componentDidMount()
    {
         this.setState({loading:0})
           
    }


    render()
    { 
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
    return (
        <div>

          <div class="section-full p-t80 p-b50 bg-gray">
                <div class="container">
                
                     
                    <div class="m-b50">
                        <div class="section-head">
                            <h2 class="text-uppercase">Services</h2>
                            <div class="wt-separator-outer">
                                    <div class="wt-separator style-square">
                                       
                                        <span class="separator-right site-bg-primary"></span>
                                    </div>
                                </div>
                        </div>
                        <div class="section-content m-b20">
                            <div class="row">
                            <p>Contrive Construction Maintenance Electromechanical
specializes in delivering a wide range of services across
residential projects, multi–storey buildings, pumping
stations, infrastructure construction, and various
industrial sectors, including</p>
                                
                                 {this.props.services.services. map((item, index) => (
                                <div class="col-lg-3 col-md-6 m-b30">
                                    <div class="wt-icon-box-wraper bx-style-1  center bg-white">
                                        <img src={item.image}  alt={item.title}/>
                                        <div class="icon-content">
                                            <h5 class="wt-tilte text-uppercase">{item.title}</h5>
                                          
                                        </div>
                                    </div>
                                </div>
                                 ))}
                                
								
								<h2>Project Experiences</h2>
								<div class="wt-separator-outer">
                                    <div class="wt-separator style-square">
                                        <span class="separator-right site-bg-primary"></span>
                                    </div>
                                </div>
								
								
								<p>Contrive Construction Maintenance Electromechanical has established a strong track
record of successfully delivering fast-track projects on time, within budget, and as per
schedule, while also executing major projects on a design-and-build basis.</p>
								
							   {this.props.services.experiences. map((item, index) => (
                                <div class="col-lg-3 col-md-6 m-b30">
                                    <div class="wt-icon-box-wraper bx-style-1 center bg-white">
                                        <img src={item.image}  alt={item.title}/>
                                        <div class="icon-content">
                                            <h5 class="wt-tilte text-uppercase">{item.title}</h5>
                                          
                                        </div>
                                    </div>
                                </div>
                                 ))}
								
                            </div>
                        </div>
                    </div>
				</div>
			</div>
 
        </div>
       

    );
 
    }
}

export default ServicesContent;